"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ColorIndicator = require("./ColorIndicator.styled");
var _jsxRuntime = require("react/jsx-runtime");
var MultiColorIndicatorWrapper = _styledComponents.default.div.withConfig({
  displayName: "MultiColorIndicator__MultiColorIndicatorWrapper",
  componentId: "sc-1kbp965-0"
})(["display:flex;"]);
var MultiColorIndicatorContainer = _styledComponents.default.div.withConfig({
  displayName: "MultiColorIndicator__MultiColorIndicatorContainer",
  componentId: "sc-1kbp965-1"
})(["display:inline-block;:first-child{margin-right:", ";}"], function (_ref) {
  var size = _ref.size;
  return sizeMapping[size].margin;
});
var ColorIndicatorWrapper = (0, _styledComponents.default)(_ColorIndicator.ColorIndicatorStyled).withConfig({
  displayName: "MultiColorIndicator__ColorIndicatorWrapper",
  componentId: "sc-1kbp965-2"
})(["width:", ";height:", ";:first-child{margin-bottom:", ";}"], function (_ref2) {
  var size = _ref2.size;
  return sizeMapping[size].dimensions;
}, function (_ref3) {
  var size = _ref3.size;
  return sizeMapping[size].dimensions;
}, function (_ref4) {
  var size = _ref4.size;
  return sizeMapping[size].margin;
});
var sizeMapping = {
  s: {
    margin: '2px',
    dimensions: '9px'
  },
  m: {
    margin: '3.2px',
    dimensions: '14.4px'
  },
  l: {
    margin: '4px',
    dimensions: '18px'
  }
};
var MultiColorIndicator = function MultiColorIndicator(_ref5) {
  var color = _ref5.color,
    size = _ref5.size;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(MultiColorIndicatorWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(MultiColorIndicatorContainer, {
      size: size,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ColorIndicatorWrapper, {
        color: color,
        size: size
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ColorIndicatorWrapper, {
        color: color,
        size: size
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(MultiColorIndicatorContainer, {
      size: size,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ColorIndicatorWrapper, {
        color: color,
        size: size
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ColorIndicatorWrapper, {
        color: color,
        size: size
      })]
    })]
  });
};
MultiColorIndicator.defaultProps = {
  color: '#FF8FD0',
  size: 'm'
};
var _default = exports.default = MultiColorIndicator;